<template>
  <div class="hcoin">
    <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
      <g id="页面-1">
        <g id="iPhone-11-Pro备份-10" transform="translate(-18.000000, -110.000000)">
          <g id="编组-4" transform="translate(12.000000, 104.000000)">
            <g id="编组-7" transform="translate(6.000000, 6.000000)">
              <path id="Fill-1" :fill="reverse ? (color || '#ffffff') : (color || cc.theme_color)" class="st0" d="M16,0v8c0,4.4-3.6,8-8,8s-8-3.6-8-8s3.6-8,8-8H16z"/>
              <path class="st1" :fill="reverse ? (bg || cc.theme_color) : (bg || '#ffffff')" d="M11.7,5.3v3.2c0,1.2-0.4,2.2-1.2,3c-0.3,0.3-0.6,0.5-1,0.7c-0.1,0-0.2,0.1-0.3,0.1c-0.6,0.3-1.2,0.4-1.8,0.4H7.3c-0.1,0-0.2-0.1-0.1-0.2c0,0,0.1-0.1,0.3-0.2c0.2-0.1,0.3-0.3,0.5-0.4c0.7-0.7,1.2-1.6,1.2-2.7V8.7H6.9C6.8,9.4,6.4,10,5.6,10.5c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.2-0.3V7.5c0-1.2,0.4-2.2,1.3-3c0.3-0.3,0.6-0.5,1-0.7c0.1,0,0.2-0.1,0.3-0.1C7.3,3.3,8,3.2,8.6,3.2c0.1,0,0.1,0,0.1,0c0.1,0,0.2,0.1,0.1,0.2c0,0.1-0.1,0.1-0.3,0.2C8.5,3.7,8.3,3.9,8.1,4C7.4,4.7,7,5.6,6.9,6.6c0,0.1,0,0.1,0,0.2v0.5h2.3c0.1-0.7,0.5-1.4,1.2-1.9c0.2-0.1,0.4-0.2,0.4-0.2c0.1,0,0.2-0.1,0.3-0.1C11.2,5,11.3,5,11.4,5s0.1,0,0.1,0C11.6,5,11.7,5.1,11.7,5.3"/>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script type='text/ecmascript-6'>
export default {
  props: {
    cc: {
      type: Object,
      default: () => {}
    },
    color: {
      type: String,
      default:''
    },
    bg: {
      type: String,
      default:''
    },
    reverse: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang='less' scoped>
  .st0 {
    fill-rule:evenodd;
    clip-rule:evenodd;
    text-shadow: 3px 3px 3px rgba(0,0,0,0.5);
  }
  .st1 {
    fill-rule:evenodd;
    clip-rule:evenodd;
    text-shadow: 3px 3px 3px rgba(0,0,0,0.5);
  }
  .hcoin {
    width: 100%;
    height: 100%;
    svg {
      width: 100%;
      height: 100%;
      float: left;
    }
  }
</style>